export default __webpack_public_path__ + "static/Neubau-ad341f42eadc3543dded9845247d2366.jpg";